export const dialogMessages = {
  "authRecovery.title": "Sign in to CodeNomad again",
  "authRecovery.description": "Your CodeNomad login is no longer valid. This can happen after the server restarts. Sign in again to reconnect.",
  "authRecovery.pairing": "This device is no longer paired with CodeNomad. On the host, open Settings → Remote Access, create a new pairing link and open it on this device, then check again.",
  "authRecovery.pairingTitle": "Pair this device again",
  "authRecovery.drafts": "This page stays open to keep your drafts. After reconnecting, retry the action that failed.",
  "authRecovery.username": "Username",
  "authRecovery.password": "Password",
  "authRecovery.signIn": "Sign in",
  "authRecovery.pending": "Signing in…",
  "authRecovery.check": "Check connection",
  "authRecovery.credentials": "The username or password is incorrect.",
  "authRecovery.unavailable": "Unable to sign in. Check that the CodeNomad server is available and try again.",
  "alertDialog.fallbackTitle.info": "Heads up",
  "alertDialog.fallbackTitle.warning": "Please review",
  "alertDialog.fallbackTitle.error": "Something went wrong",
  "alertDialog.actions.confirm": "Confirm",
  "alertDialog.actions.run": "Run",
  "alertDialog.actions.ok": "OK",
  "alertDialog.actions.cancel": "Cancel",
  "alertDialog.prompt.inputLabel": "Input",

  "backgroundProcessOutputDialog.title": "Background Output",
  "backgroundProcessOutputDialog.actions.close": "Close",
  "backgroundProcessOutputDialog.loading": "Loading output...",
  "backgroundProcessOutputDialog.truncatedNotice": "Output truncated for display.",
  "backgroundProcessOutputDialog.loadErrorFallback": "Failed to load output.",
} as const
